import { render, staticRenderFns } from "./PeopleKpiEditDiscretionaryPrize.vue?vue&type=template&id=82e90fae"
import script from "./PeopleKpiEditDiscretionaryPrize.vue?vue&type=script&lang=js"
export * from "./PeopleKpiEditDiscretionaryPrize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports